<script>
export default {
  props: {
    headerTitle: { type: String, default: '' },
    headerContent: { type: String, default: '' },
  },
};
</script>

<template>
  <div class="flex flex-col items-start w-full gap-2 mb-6">
    <h2
      class="text-2xl font-semibold tracking-tight break-words text-n-slate-12"
    >
      {{ headerTitle }}
    </h2>
    <p
      v-dompurify-html="headerContent"
      class="w-full mb-0 text-sm leading-6 text-n-slate-11"
    />
  </div>
</template>
